<script setup lang="ts">
import DefaultModalBase from "../DefaultModalBase.vue";
import {useOrderStore} from "../../../store/orders"
import {useModalStore} from "../../../store/modal"
import {computed, onMounted, ref} from "vue";

const loading = ref(false)
const store = useOrderStore()
const modalStore = useModalStore()
const is_dormant = ref(false)
const reason = ref('')

const disabled = computed(() => loading.value || !reason.value)

const dormantOrder = async () => {
    loading.value = true
    await store.dormantOrder(reason.value)

    loading.value = false
    is_dormant.value = true
}

onMounted(async () => {
})
</script>

<template>
<DefaultModalBase :heading="is_dormant ? 'Order Dormanted' : 'Dormant Order'" :icon="is_dormant ? 'check-all' : 'cross-default'" :loading :refresh="is_dormant">

    <div class="call-assign-container">
        <brand-form-textarea label="Reason for dormanting." v-model="reason" v-if="!is_dormant"/>
        <brand-button @click="dormantOrder()" :disabled v-if="!is_dormant">Dormant Order</brand-button>
        <brand-button variant="secondary" v-if="is_dormant" @click="modalStore.close(true)">Done</brand-button>
    </div>
</DefaultModalBase>
</template>

<style scoped lang="scss">
.call-assign-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
}
</style>
